import {Suspense, useMemo} from 'react'
import {Outlet, useLocation} from 'react-router-dom'
import {HelmetProvider} from 'react-helmet-async'
import {I18nProvider} from '../_gori/i18n/i18nProvider'
import {LayoutProvider, LayoutSplashScreen} from '../_gori/layout/core'
import {MasterInit} from '../_gori/layout/MasterInit'
import {AuthInit, useAuth} from './modules/auth'
import {ToastContainer} from 'react-toastify'

import AutoScrollToTop from '../_gori/layout/components/AutoScrollToTop'
import {HelpCenterWidget} from './modules/common/components/HelpCenterWidget'
import {HELP_CENTER_WIDGET_ROUTE_BLACKLIST} from './modules/help-center/core/_const'

// NOTE: prod only
const CHATBOT_WHITELIST_EMAIL_IDENTIFIER = ['@goricompany']
const CHATBOT_WHITELIST_USERNAME_IDENTIFIER = ['admin', 'ntq', 'test', 'test2']

const AppContent = () => {
  const location = useLocation()
  const {accountIdentity} = useAuth()

  const visibleChatbotWidget = useMemo(() => {
    return (
      !HELP_CENTER_WIDGET_ROUTE_BLACKLIST.includes(location.pathname) &&
      (CHATBOT_WHITELIST_EMAIL_IDENTIFIER.some((identifier) =>
        accountIdentity?.email?.includes(identifier)
      ) ||
        CHATBOT_WHITELIST_USERNAME_IDENTIFIER.some((item) => accountIdentity?.username === item))
    )
  }, [location.pathname, accountIdentity?.email, accountIdentity?.username])

  return (
    <>
      <Suspense fallback={<LayoutSplashScreen />}>
        <I18nProvider>
          <LayoutProvider>
            <AuthInit>
              <Outlet />
              <MasterInit />
              {visibleChatbotWidget && <HelpCenterWidget />}
              <ToastContainer position='top-right' autoClose={5000} />
            </AuthInit>
          </LayoutProvider>
        </I18nProvider>
        <AutoScrollToTop />
      </Suspense>
    </>
  )
}

const App = () => {
  return (
    <HelmetProvider>
      <AppContent />
    </HelmetProvider>
  )
}

export {App}
